import Header from '@package/components/Header';

export default Header;
